module.exports = __webpack_public_path__ + "static/media/6_r_lenta_71.72_5.28.55609ac7.png";